export const TOGGLE_SPARKED_MODE = 'TOGGLE_SPARKED_MODE'

export function sparkedModeReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_SPARKED_MODE:
            return action.payload
        default: return state
    }
}